import httpUmbraco from './httpUmbraco'

export const getContent = () => {
  return httpUmbraco.get('/api/content/calculator')
}

export default { getContent }